import React, { useState, useRef, useEffect } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { Edit, X, Save } from "react-feather";
import { InputText } from "../../ui/inputs";
import { Container } from "./detail";
import { validateEmail } from "../../components/CandidatosNP/utils";

const ContactNP = ({ nota, anularCancelar, handleEditData }) => {
  const inputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);

  const [modifyingNombre, setModifyingNombre] = useState(false);
  const [nombre, setNombre] = useState("");

  const [modifyingEmail, setModifyingEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [modifyingTelefono, setModifyingTelefono] = useState(false);
  const [telefono, setTelefono] = useState("");
  const [telefonoError, setTelefonoError] = useState(false);

  useEffect(() => {
    if (nota && nota.contactoNombre) setNombre(nota.contactoNombre);
    else setNombre("-");
    if (nota && nota.contactoEmail) setEmail(nota.contactoEmail);
    else setEmail("-");
    if (nota && nota.contactoTelefono) setTelefono(nota.contactoTelefono);
    else setTelefono("-");
  }, [nota]);

  useEffect(() => {
    // Enfocar el input cuando el componente se monte
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleNombreChange = () => {
    handleEditData({ nombre });
    setModifyingNombre(!modifyingNombre);
  };

  const handleEmailChange = () => {
    if (validateEmail(email)) {
      handleEditData({ email });
      setModifyingEmail(!modifyingEmail);
      setEmailError(null);
    } else {
      setEmailError("Formato de email incorrecto");
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    const re = /^\+?(\d{1,3})?[-. (]?(\d{3})[-. )]?(\d{3})[-. ]?(\d{4})$/;
    return re.test(phoneNumber);
  };

  const handleTelefonoChange = () => {
    if (validatePhoneNumber(telefono)) {
      handleEditData({ telefono });
      setModifyingTelefono(!modifyingTelefono);
      setTelefonoError(null);
    } else {
      setTelefonoError("Formato de teléfono incorrecto");
    }
  };

  return (
    <>
      <Card className="h-100 mb-0">
        <CardBody className="py-3">
          <Container>
            <div className="text-muted font">Razon social: </div>
            <div className="d-flex justify-content-between align-items-center font">{nota ? nota.razonSocial : "-"}</div>
            <hr />

            <div className="text-muted font">Nombre: </div>
            <div className="d-flex justify-content-between align-items-center font">
              {modifyingNombre ? (
                <>
                  <div className="mb-1">
                    <InputText type="text" id="nombre" name="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} maxLength={40} ref={inputRef} />
                  </div>
                  <div style={{ width: "25px" }}>
                    <Button size="xs" color="link" onClick={() => handleNombreChange()}>
                      <Save size="18" color="#293134" />
                    </Button>
                    <Button size="xs" color="link" onClick={() => setModifyingNombre(!modifyingNombre)}>
                      <X size="18" color="#293134" />
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  {nombre || "-"}
                  <div>
                    <Button
                      size="xs"
                      id="btnModifyingAsignado"
                      color="link"
                      onClick={() => {
                        setModifyingNombre(!modifyingNombre);
                        setIsEditing("nombre");
                      }}
                      disabled={anularCancelar}
                    >
                      <Edit size="20" color="#293134" />
                    </Button>
                  </div>
                </>
              )}
            </div>
            <hr />

            <div className="text-muted font">Email: </div>
            <div className="d-flex justify-content-between align-items-center font">
              {modifyingEmail ? (
                <>
                  <div className="mb-1">
                    <InputText
                      style={emailError ? { borderBottom: "1px solid red" } : null}
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      maxLength={50}
                      ref={inputRef}
                    />
                    {emailError && <small className="text-danger">{emailError}</small>}
                  </div>
                  <div style={{ width: "25px" }}>
                    <Button size="xs" color="link" onClick={() => handleEmailChange()}>
                      <Save size="18" color="#293134" />
                    </Button>
                    <Button size="xs" color="link" onClick={() => setModifyingEmail(!modifyingEmail)}>
                      <X size="18" color="#293134" />
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  {email || "-"}
                  <div>
                    <Button
                      size="xs"
                      id="btnModifyingAsignado"
                      color="link"
                      onClick={() => {
                        setModifyingEmail(!modifyingEmail);
                        setModifyingEmail("email");
                      }}
                      disabled={anularCancelar}
                    >
                      <Edit size="20" color="#293134" />
                    </Button>
                  </div>
                </>
              )}
            </div>
            <hr />

            <div className="text-muted font">Teléfono: </div>
            <div className="d-flex justify-content-between align-items-center font">
              {modifyingTelefono ? (
                <>
                  <div className="mb-1">
                    <InputText
                      style={telefonoError ? { borderBottom: "1px solid red" } : null}
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={telefono}
                      onChange={(e) => setTelefono(e.target.value)}
                      maxLength={50}
                      ref={inputRef}
                    />
                    {telefonoError && <small className="text-danger">{telefonoError}</small>}
                  </div>
                  <div style={{ width: "25px" }}>
                    <Button size="xs" color="link" onClick={() => handleTelefonoChange()}>
                      <Save size="18" color="#293134" />
                    </Button>
                    <Button size="xs" color="link" onClick={() => setModifyingTelefono(!modifyingTelefono)}>
                      <X size="18" color="#293134" />
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  {telefono || "-"}
                  <div>
                    <Button
                      size="xs"
                      id="btnModifyingAsignado"
                      color="link"
                      onClick={() => {
                        setModifyingTelefono(!modifyingTelefono);
                        setIsEditing("telefono");
                      }}
                      disabled={anularCancelar}
                    >
                      <Edit size="20" color="#293134" />
                    </Button>
                  </div>
                </>
              )}
            </div>
            <hr />
          </Container>
        </CardBody>
      </Card>
    </>
  );
};

export default ContactNP;
